export enum SharedBoxAttachmentOption {
    SignatureRequired = 'SIGNATURE_REQUIRE',
};

export enum SharedBoxRecipientType {
    None = 'NONE',
    EmailAddress = 'EMAIL_ADDRESS',
    AMCUserId = 'AMC_USERID',
    AMCGroupId = 'AMC_GROUPID',
}

export const SharedBoxRecipientTypeLabel = {
    EMAIL_ADDRESS: 'Email Address',
    AMC_USERID: 'User (AMC)',
    AMC_GROUPID: 'Group (AMC)',
};

export interface SharedBoxRecipient {
    id: string;
    type: SharedBoxRecipientType;
    value: string;
    passcode?: string;
    lastRead: null|Date;
    isOwner: boolean;
    canAccess: boolean|null;
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
    // Virtual Properties
    aliasName?: string;
}

export interface SharedBoxAttachment {
    id: string;
    filename: string;
    fileSize?: string;
    options: Array<SharedBoxAttachmentOption>;
    signatureRequired?: boolean;
    createdAt: string;
}

export interface SharedBoxMessage {
    id: string;
    hash?: string;
    message: string;
    recipientId: string;
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
    attachments?: Array<SharedBoxAttachment>;
    // Virtual Properties
    recipient?: SharedBoxRecipient;
    isMe?: boolean;
    isNewMessage?: boolean;
}

export type CompanyDomainTypes = 'FIDUCIAL'|'FIDUCIAL_JADE'|'FIDUCIAL_FEDERATED';

export interface SharedBox {
    id: string;
    hash?: string;
    label: string;
    canReplyAttachment: boolean;
    canReplyText: boolean;
    recipients: Array<SharedBoxRecipient>;
    messages: Array<SharedBoxMessage>;
    companyDomain: CompanyDomainTypes;
    recipientDictionary?: {
        [key: string]: SharedBoxRecipient;
    };
}